var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAccountbalance(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "13px",
    height: "24px",
    viewBox: "0 0 13 24",
    enableBackground: "new 0 0 13 24",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#486AE4",
    d: "M0.682,23.272h11.637c0.377,0,0.682-0.305,0.682-0.682V4.728c0-0.377-0.305-0.682-0.682-0.682H0.682 C0.305,4.045,0,4.351,0,4.728v17.863C0,22.968,0.305,23.272,0.682,23.272z M11.637,21.909H1.364v-16.5h10.273V21.909z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#486AE4",
    d: "M0.682,5.409h10.182c0.377,0,0.682-0.305,0.682-0.682V0.682c0-0.226-0.111-0.437-0.299-0.564 c-0.187-0.127-0.424-0.153-0.635-0.069L0.43,4.094c-0.304,0.121-0.479,0.44-0.418,0.762S0.354,5.409,0.682,5.409z M10.182,4.045 H4.245l5.937-2.359V4.045z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#486AE4",
    d: "M9.409,14.682H3.591c-0.376,0-0.682-0.305-0.682-0.682s0.305-0.682,0.682-0.682h5.818 c0.376,0,0.682,0.305,0.682,0.682S9.785,14.682,9.409,14.682z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#486AE4",
    d: "M9.409,18.682H3.591c-0.376,0-0.682-0.305-0.682-0.682s0.305-0.682,0.682-0.682h5.818 c0.376,0,0.682,0.305,0.682,0.682S9.785,18.682,9.409,18.682z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#486AE4",
    d: "M9.409,10.682H3.591c-0.376,0-0.682-0.305-0.682-0.682s0.305-0.682,0.682-0.682h5.818 c0.376,0,0.682,0.305,0.682,0.682S9.785,10.682,9.409,10.682z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccountbalance);
export default __webpack_public_path__ + "static/media/accountbalance.347cfff6c81bcdb49f59fc2674699234.svg";
export { ForwardRef as ReactComponent };